export const types = {
  GET_AVAILABLE_LANGUAGES: {
    FAILURE: 'GET_AVAILABLE_LANGUAGES.FAILURE',
    SUCCESS: 'GET_AVAILABLE_LANGUAGES.SUCCESS',
    REQUEST: 'GET_AVAILABLE_LANGUAGES.REQUEST',
  },
};

export const getAvailableLanguagesSuccessAction = (payload) => ({
  type: types.GET_AVAILABLE_LANGUAGES.SUCCESS,
  payload,
});
export const getAvailableLanguagesFailureAction = (payload) => ({
  type: types.GET_AVAILABLE_LANGUAGES.FAILURE,
  payload,
});
export const getAvailableLanguagesRequestAction = (payload) => ({
  type: types.GET_AVAILABLE_LANGUAGES.REQUEST,
  payload,
});



// WEBPACK FOOTER //
// ./redux/actions/trscService.js